module.exports = __webpack_public_path__ + "img/Primordial-1.368fd148.png";